import { render, staticRenderFns } from "./FooterComponentBbg.vue?vue&type=template&id=69fe2fb1"
import script from "./FooterComponentBbg.vue?vue&type=script&lang=ts"
export * from "./FooterComponentBbg.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentBbg.vue?vue&type=style&index=0&id=69fe2fb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports